<template>
  <div id="menu">
    <div class="menu__logo" @click="goTo('/')">
      <svg xmlns="http://www.w3.org/2000/svg" width="150" height="100%" viewBox="0 0 175 45"><g id="logo-alegra" fill="none" fill-rule="evenodd"><path class="logo-symbol" fill="#FFF" fill-rule="nonzero" d="M52.4,34.3 C52.4,34.3 38.4,41 22.9,37.4 C13.5,35.2 0,27.5 0,27.5 L14,8.9 C14,8.9 20.7,19.4 28.9,25.8 C43.1,36.9 52.4,34.3 52.4,34.3 M47.7,31.8 C47.7,31.8 41.2,29.1 38,16.4 C36.1,9 37,0 37,0 L20.6,4.4 C20.6,4.4 24.9,14.9 29.3,20.4 C36.6,29.4 47.7,31.8 47.7,31.8 M46.1,27.8 C46.1,27.8 44,23.5 48,15.6 C50.3,11 54.8,6.8 54.8,6.8 L44.5,1.7 C44.5,1.7 42,8.9 41.8,13.7 C41.6,21.6 46.1,27.8 46.1,27.8 M47.4,23.8 C47.4,23.8 48.3,21.2 53.2,19.6 C56,18.7 59.6,18.8 59.6,18.8 L57.4,12.5 C57.4,12.5 53.4,14.5 51.4,16.3 C48.1,19.4 47.4,23.8 47.4,23.8"></path><path class="logo-text" fill="#FFF" fill-rule="nonzero" d="M90,34.8 L92.5,34.8 L92.5,5.4 L90,5.4 L90,34.8 Z M147.2,18.8 L147.2,15.5 L144.7,15.5 L144.7,34.8 L147.3,34.8 L147.3,24.1 C147.3,22.1 147.7,20.8 149.3,19.5 C150.4,18.6 151.4,18.3 152.8,18.2 L152.8,15.6 C150.3,15.8 148.5,16.4 147.2,18.8 L147.2,18.8 Z M115.5,21.6 C114.1,17.7 110.3,15.1 106.1,15.1 C100.5,15.1 96.1,19.7 96.1,25.2 C96.1,30.7 100.6,35.3 106.1,35.3 C110,35.3 113.7,32.9 115.3,29.3 L112.5,29.3 C111.2,31.5 108.6,33.1 106.1,33.1 C102.3,33.1 98.9,29.9 98.7,26.1 L116.2,26.1 C116.1,24.5 116.1,23.1 115.5,21.6 L115.5,21.6 Z M98.7,23.9 C99.3,20.2 102.3,17.3 106.1,17.3 C110,17.3 112.7,20.3 113.5,23.9 L98.7,23.9 Z M83.3,18.6 C81.8,16.7 78.8,15.1 75.7,15.1 C70,15.1 65.3,19.4 65.3,25.2 C65.3,30.9 70,35.3 75.7,35.3 C78.9,35.3 81.4,34 83.3,31.5 L83.3,34.9 L85.8,34.9 L85.8,25.6 L85.8,25.6 C85.8,25.5 85.8,25.4 85.8,25.3 C85.8,22.6 84.9,20.3 83.3,18.6 L83.3,18.6 Z M75.7,33.1 C71.4,33.1 67.8,29.5 67.8,25.2 C67.8,20.9 71.4,17.3 75.7,17.3 C80,17.3 83.3,21 83.3,25.2 C83.3,29.4 80,33.1 75.7,33.1 L75.7,33.1 Z M174.4,25.2 C174.4,22.6 173.5,20.3 171.9,18.6 C170.4,16.7 167.4,15.1 164.3,15.1 C158.6,15.1 153.9,19.4 153.9,25.2 C153.9,30.9 158.6,35.3 164.3,35.3 C167.5,35.3 170,34 171.9,31.5 L171.9,34.9 L174.4,34.9 L174.4,25.6 L174.4,25.6 C174.4,25.4 174.4,25.3 174.4,25.2 L174.4,25.2 Z M164.3,33.1 C160,33.1 156.4,29.5 156.4,25.2 C156.4,20.9 160,17.3 164.3,17.3 C168.6,17.3 171.9,21 171.9,25.2 C171.9,29.4 168.5,33.1 164.3,33.1 L164.3,33.1 Z M137.6,18.5 C136.2,16.5 133.1,15.1 129.9,15.1 C124.3,15.1 120,19.9 120,25.3 C120,30.8 124.5,35.3 130,35.3 C133,35.3 136.3,33.9 137.5,31 L137.5,35.3 C137.5,39.4 134.5,42.3 130.3,42.3 C128.7,42.3 127,41.8 125.7,40.8 C124.6,40 123.8,38.6 123.1,37.4 L120.6,37.4 C121,38.5 121.3,39.3 121.9,40.3 C123.7,42.9 126.9,44.5 130.1,44.5 C133.1,44.5 136.2,43.2 138.2,40.9 C139.8,38.9 140,37.3 140,34.7 L140,25.3 C140.1,22.8 139.2,20.4 137.6,18.5 L137.6,18.5 Z M130.1,33.1 C125.7,33.1 122.5,29.4 122.5,25.1 C122.5,20.9 125.6,17.3 129.9,17.3 C134.2,17.3 137.6,20.9 137.6,25.1 C137.6,29.3 134.4,33.1 130.1,33.1 L130.1,33.1 Z"></path><text class="logo-country" fill="#FFF" font-family="Roboto" font-size="9" font-weight="normal" opacity="1"><tspan x="100%" y="8" text-anchor="end">LENDING</tspan></text></g></svg>
    </div>
    <nav class="menu__nav">
      <div class="menu__nav__item" @click="goTo(isFilterActive && !isFourthStep ? '/prospects/add' : '/')">
        <svg class="menu__nav__item__icon" width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0.543289 7.88284C0.91874 8.20649 1.47463 8.20625 1.8498 7.88227L8.94995 1.75093L16.2466 8.05016C16.622 8.37423 17.1782 8.37423 17.5535 8.05016L17.9995 7.66514L9.60352 0.415477C9.2281 0.0913171 8.67181 0.0913266 8.2964 0.415499L0.0957031 7.497L0.543289 7.88284ZM9.75219 5.44514L12.0963 7.48027L14.7511 9.78394C14.97 9.97388 15.0957 10.2494 15.0957 10.5392V15.2499C15.0957 15.8022 14.648 16.2499 14.0957 16.2499H11.3286V11.2541C11.3286 10.7018 10.8809 10.2541 10.3286 10.2541H7.86278C7.3105 10.2541 6.86278 10.7018 6.86278 11.2541V16.2499H4.0957C3.54342 16.2499 3.0957 15.8022 3.0957 15.2499V10.5392C3.0957 10.2494 3.22143 9.97388 3.44031 9.78395L6.09513 7.48027L8.4413 5.44489C8.81739 5.11862 9.37622 5.11873 9.75219 5.44514Z" fill="white"/>
        </svg>
        <span class="menu__nav__item__text">INICIO</span>
      </div>

      <div class="menu__nav__item" @click="goTo('/prospects')">
        <svg class="menu__nav__item__icon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M10.231 0.0859216C9.82883 0.0292875 9.41784 0 9 0C4.16751 0 0.25 3.91751 0.25 8.75C0.25 13.5825 4.16751 17.5 9 17.5C13.8325 17.5 17.75 13.5825 17.75 8.75C17.75 8.05328 17.6686 7.37557 17.5147 6.72589L16.2184 8.06828C16.2393 8.29271 16.25 8.52011 16.25 8.75C16.25 12.7541 13.0041 16 9 16C4.99594 16 1.75 12.7541 1.75 8.75C1.75 4.79127 4.92285 1.5736 8.86429 1.50124L10.231 0.0859216ZM8.49348 10.7522L13.6066 5.63909C13.8995 5.34619 13.8995 4.87132 13.6066 4.57843C13.3137 4.28553 12.8388 4.28553 12.5459 4.57843L7.43282 9.69155L7.0877 7.16076L5.61067 6.9175L6.28951 11.8955L11.2675 12.5744L11.0243 11.0973L8.49348 10.7522Z" fill="white"/>
        </svg>
        <span class="menu__nav__item__text">ESTADO DE SOLICITUDES</span>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'LeftBar',
  methods: {
    goTo (path) {
      if (this.$route.path === path) {
        return null
      }

      if (this.isFourthStep) {
        this.$store.dispatch('finalStepReset', path)
      } else {
        this.$store.dispatch('noFinalStepReset', path)
      }
    }
  },
  computed: {
    isFourthStep () {
      return this.$store.getters.isFourthStep
    },
    isFilterActive () {
      return this.$store.getters.isFilterActive
    }
  }
}
</script>

<style>
#menu {
  color: #ffffff;

  background: #00b19d;
  height: 100vh;
  width: 100%;
}

.menu__logo {
  border-bottom: rgba(0, 0, 0, 0.07);
  border-style: solid;
  border-width: 0 0 1px 0;
  cursor: pointer;
  padding: 20px 0;
}

.menu__nav__item {
  align-items: center;
  border-bottom: rgba(0, 0, 0, 0.07);
  border-style: solid;
  border-width: 0 0 1px 0;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  height: 40px;
  justify-content: flex-start;
  width: 100%;
}

.menu__nav__item:hover {
  background: rgba(0, 0, 0, 0.07);
}

.menu__nav__item__icon {
  color: #ffffff;

  margin: 0 10px 0 15px;
}

.menu__nav__item__text {
  color: #ffffff;
  font-size: 12px;
}
</style>
